var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlueLocationOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 21,
    viewBox: "0 0 15 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.49967 9.97921C6.80901 9.97921 6.14663 9.70484 5.65825 9.21646C5.16987 8.72809 4.89551 8.06571 4.89551 7.37504C4.89551 6.68437 5.16987 6.02199 5.65825 5.53362C6.14663 5.04524 6.80901 4.77087 7.49967 4.77087C8.19034 4.77087 8.85272 5.04524 9.3411 5.53362C9.82947 6.02199 10.1038 6.68437 10.1038 7.37504C10.1038 7.71702 10.0365 8.05566 9.90561 8.37161C9.77474 8.68756 9.58292 8.97464 9.3411 9.21646C9.09928 9.45828 8.8122 9.65011 8.49625 9.78098C8.18029 9.91185 7.84166 9.97921 7.49967 9.97921ZM7.49967 0.083374C5.5658 0.083374 3.71114 0.851601 2.34369 2.21905C0.976235 3.58651 0.208008 5.44117 0.208008 7.37504C0.208008 12.8438 7.49967 20.9167 7.49967 20.9167C7.49967 20.9167 14.7913 12.8438 14.7913 7.37504C14.7913 5.44117 14.0231 3.58651 12.6557 2.21905C11.2882 0.851601 9.43354 0.083374 7.49967 0.083374Z",
    fill: "#051C34"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueLocationOutline);
export default __webpack_public_path__ + "static/media/blueLocationOutline.0f6bfc0443199ca6dca424cbdec45660.svg";
export { ForwardRef as ReactComponent };